export default {
  name: 'SettingFinancialBank',

  props: {
    form: {
      bankName: String,
      branchName: String,
      accountType: String,
      accountNumber: String,
      accountName: String
    },
    disabled: Boolean
  },

  watch: {
    form: {
      handler: function(newValue) {
        if (!newValue.accountType) {
          newValue.accountType = '-';
        }

        return newValue;
      },
      immediate: true
    }
  },

  data: function() {
    return {
      accountTypes: [
        {
          label: '-',
          disabled: true,
          value: '-'
        },
        {
          label: '普通',
          value: 'saving'
        },
        {
          label: '当座',
          value: 'checking'
        }
      ]
    };
  },

  methods: {
    emitFormChange: function() {
      this.$emit('bank-account-info', this.form);
    }
  }
};
